// components/ControllerTabs.js

import React, { useEffect, useState } from "react";
import logo from "../media/logo.png";
import { BMLogo, BMWordmark, CollapseIcon, DarkModeIcon, LightMode, LightModeIcon, PlusIcon, SettingsAltIcon, SettingsIcon, UndoIcon } from "../utils/Icons";
import { kbdEvent } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import Space from "../ui/Space";
import Cookies from "js-cookie";
import Divider from "../ui/Divider";

export default function MainNav({ controllers = [], mounted = {}, active = "", onSelect = () => { }, top = 90, }) {




    const [expanded, setExpanded] = useState(Cookies.get("main-nav-expanded") || "true");

    const [theme, setTheme] = useState(() => document.documentElement.getAttribute("data-theme") || "dark");

    const toggleTheme = () => {
        setTheme(prev => prev === "dark" ? "light" : "dark");
    };

    const toggleNav = () => {

        if (Cookies.get("main-nav-expanded") !== "false") {
            Cookies.set("main-nav-expanded", "false", { expires: 365 });
            setExpanded("false")
        } else {
            Cookies.set("main-nav-expanded", "true", { expires: 365 });
            setExpanded("true")
        }
    };

    useEffect(() => {
        document.documentElement.setAttribute("data-theme", theme);
    }, [theme]);


    return (
        <div className={(expanded === "false" ? "ui-main-nav collapsed" : "ui-main-nav")}>
            <div className="ui-main-nav-logo">
                {/* <BMWordmark /> */}
                <BMLogo />


            </div>
            <div className="ui-main-nav-items">
                {controllers.map((item) => {

                    const isMounted = !!mounted[item.key];
                    const isActive = active === item.key;

                    return (
                        <div
                            key={item.key}
                            onClick={() => {
                                if (item.enabled) {
                                    onSelect(item.key)
                                }
                            }}
                            title={item.label}
                            className={[
                                "ui-main-nav-item",
                                isActive ? "active" : "",
                                !isMounted ? "unmounted" : "",
                                !item.enabled ? "disabled" : "",
                            ].join(" ")}
                        >
                            <div className="ui-main-nav-icon">
                                {item.icon}
                            </div>

                            <span className="ui-main-nav-label">
                                {item.label}
                            </span>


                        </div>
                    );
                })}

                <div className="ui-main-nav-bottom">


                    {window.beta &&
                        <>
                            <div onClick={() => { toggleTheme() }} className="ui-main-nav-item" title="Settings" >
                                <div className="ui-main-nav-icon">
                                    {theme !== "dark" && <LightModeIcon />}
                                    {theme == "dark" && <DarkModeIcon />}
                                </div>
                                <span className="ui-main-nav-label">
                                    {(theme !== "dark" ? "Light mode" : "Dark Mode")}
                                </span>
                            </div>
                            <div className="shim" /><div className="shim" /><div className="shim" />
                        </>

                    }
                    {(!window.beta &&
                        <>
                            <div className="ui-main-nav-item" title="Settings" >
                                <div onClick={() => { kbdEvent(KBD.ALT_S) }} className="ui-main-nav-icon">
                                    <SettingsAltIcon />
                                </div>
                                <span className="ui-main-nav-label">
                                    Settings
                                </span>
                            </div>
                            <div className="shim" />
                            <div onClick={() => { toggleTheme() }} className="ui-main-nav-item" title="Settings" >
                                <div className="ui-main-nav-icon">
                                    {theme === "dark" && <LightModeIcon />}
                                    {theme !== "dark" && <DarkModeIcon />}
                                </div>
                                <span className="ui-main-nav-label">
                                    {(theme === "dark" ? "Light mode" : "Dark Mode")}
                                </span>
                            </div>
                        </>
                    )}
                    <div className="shim" /><div className="shim" />
                    <div className="shim" style={{ "backgroundColor": "#333", "height": "1px" }} />
                    <div className="shim" />
                    <div onClick={() => { toggleNav() }} className="ui-main-nav-item ui-main-collapse" >
                        <div className="ui-main-nav-icon">
                            <div style={{ "transform": (expanded === "false") ? "scaleX(1)" : "scaleX(-1)" }}><CollapseIcon /></div>
                        </div>
                        <span className="ui-main-nav-label">
                            <small style={{ "opacity": "0.8" }}>Collapse sidebar</small>
                        </span>

                    </div>

                </div>





            </div>
        </div>
    );
}